import { RouteRecordRaw } from "vue-router";

const kbRoute: RouteRecordRaw =
{
  path: '/kb/scraping',
  name: 'kb',
  component: () => import(/* webpackChunkName: "MainView" */ '@kb/views/MainView.vue'),
  children: [
    {
      path: 'intro',
      name: 'intro',
      component: () => import(/* webpackChunkName: "Intro" */ '@kb/components/organisms/scraping/Intro.vue'),
    },
    {
      path: 'agree',
      name: 'agree',
      component: () => import(/* webpackChunkName: "Agree" */ '@kb/components/organisms/scraping/Agree.vue'),
    },
    {
      path: 'request',
      name: 'request',
      component: () => import(/* webpackChunkName: "Request" */ '@kb/components/organisms/scraping/Request.vue'),
    },
    {
      path: 'confirm',
      name: 'confirm',
      component: () => import(/* webpackChunkName: "Confirm" */ '@kb/components/organisms/scraping/Confirm.vue'),
    },
    {
      path: ':code',
      name: 'result',
      component: () => import(/* webpackChunkName: "Result" */ '@kb/components/organisms/scraping/Result.vue'),
    }
  ]
};

const routes: Array<RouteRecordRaw> = [ kbRoute ];

export default routes;